module.exports = __webpack_public_path__ + "static/media/wm-gigafactory-aerial.75952a82.jpg";